import { render, staticRenderFns } from "./ThreedGroupBox.vue?vue&type=template&id=811b3a16&scoped=true"
import script from "./ThreedGroupBox.vue?vue&type=script&lang=js"
export * from "./ThreedGroupBox.vue?vue&type=script&lang=js"
import style0 from "./ThreedGroupBox.vue?vue&type=style&index=0&id=811b3a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811b3a16",
  null
  
)

export default component.exports